import { create } from 'zustand';

import { BdmResponse, RegionResponse, bdmGetAll, regionGetAll } from '@pmp/api';

type RegionsBdmsStore = {
  regions: RegionResponse[];
  bdms: BdmResponse[];
  hasLoaded: boolean;
  loading: boolean;
  refreshing: boolean;
  error: unknown;
  refresh: () => Promise<void>;
};

export const useRegionsBdmsStore = create<RegionsBdmsStore>((set, get) => ({
  regions: [],
  bdms: [],
  hasLoaded: false,
  loading: false,
  refreshing: false,
  error: undefined,

  // Stale-while-revalidate: keep showing the cached lists while refetching; only spin on first load.
  refresh: async () => {
    set({ loading: !get().hasLoaded, refreshing: true, error: undefined });
    try {
      const [regionsRes, bdmsRes] = await Promise.all([regionGetAll(), bdmGetAll()]);
      set({
        regions: regionsRes.data ?? [],
        bdms: bdmsRes.data ?? [],
        hasLoaded: true,
        loading: false,
        refreshing: false,
      });
    } catch (error) {
      set({ loading: false, refreshing: false, error });
    }
  },
}));
